import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import EmploymentList from './EmploymentList';
import MusicianList from './MusicianList';
import TravelExpenseList from './TravelExpenseList';
import AttachmentList from './AttachmentList';
import ReportSelect from './ReportSelect';
import template from './templates/ActionBar.html?raw';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// NOTE (JS2TS): dropped dead dojo deps (dom-attr, _base/connect).

class ActionBar extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    item: any = null;
    _currentSelectedButton: any = null;
    _employmentList: any = null;
    _expensesList: any = null;
    _fileList: any = null;
    _musicianList: any = null;
    _reportSelect: any = null;
    buttonMap: any = [];

    startup(): void {


        this.buttonMap = [{
            attachpoint: "employmentBtn",
            enabled: false,
            selected: false,
            event: null,
            clickFct: "_onClickEmployments"
        },
        {
            attachpoint: "musicianBtn",
            enabled: false,
            selected: false,
            event: null,
            clickFct: "_onClickMusicians"
        },
        {
            attachpoint: "expensesBtn",
            enabled: false,
            selected: false,
            event: null,
            clickFct: "_onClickExpenses"
        },
        {
            attachpoint: "filesBtn",
            enabled: false,
            selected: false,
            event: null,
            clickFct: "_onClickFiles"
        },
        {
            attachpoint: "reportsBtn",
            enabled: false,
            selected: false,
            event: null,
            clickFct: "_onClickReports"
        }];


        this._setButtonStates();
    }

    _setButtonStates(): void {
        if (this.item != null) {
            var bCheck = false;
            var clickFct = "";
            for (var i = 0; i < this.buttonMap.length; i++) {
                var map = this.buttonMap[i];
                var button = this[map.attachpoint];

                switch (map.attachpoint) {
                    case "musicianBtn":
                        bCheck = this.item.LvlMusicans > 0;
                        break;

                    case "employmentBtn":
                        bCheck = this.item.LvlEmployments > 0;
                        break;

                    case "expensesBtn":
                        bCheck = this.item.LvlTravelExpenses > 0;
                        break;

                    case "filesBtn":
                        bCheck = this.item.LvlAttachmentList > 0;
                        break;

                    case "reportsBtn":
                        bCheck = this.item.bShowReportsTab === true;
                        break;

                    default:
                        bCheck = this.item.is_publish_in_webtool == 1;
                        break;
                }

                if (bCheck === true) {
                    map.enabled = true;

                    if (this._currentSelectedButton == button) {
                        map.selected = true;
                    } else {
                        map.selected = false;
                    }

                    if (map.event == null) {
                        clickFct = map.clickFct;
                        map.event = on(button, "click", lang.hitch(this, clickFct));
                    }

                } else {
                    map.enabled = false;
                    // clickevent entfernen falls schon drauf
                    if (map.event != null) {
                        map.event.remove();
                    }
                }

                this._setButtonState(map);
            }
        }
    }

    _setButtonState(buttonMap: any): void {
        var targetState = "disabled";

        if (buttonMap.enabled === true) {
            targetState = "enabled";
            if (buttonMap.selected === true) {
                targetState = "selected";
            }
        }

        var buttonNode = this[buttonMap.attachpoint];

        if (targetState == "disabled") {
            domClass.remove(buttonNode, "w3-button");
            domClass.add(buttonNode, "w3-disabled");
            domClass.remove(buttonNode, "w3-white");
        }

        if (targetState == "enabled") {
            domClass.add(buttonNode, "w3-button");
            domClass.remove(buttonNode, "w3-disabled");
            domClass.remove(buttonNode, "w3-white");
        }

        if (targetState == "selected") {
            //domClass.remove(buttonNode, "w3-button");
            domClass.remove(buttonNode, "w3-disabled");
            domClass.add(buttonNode, "w3-white");

            this._currentSelectedButton = buttonNode;
        }
    }

    _onClickEmployments(evt: any): void {
        if (this._currentSelectedButton != this.employmentBtn) {
            this._currentSelectedButton = this.employmentBtn;
            this.showEmploymentList();
        } else {
            this.hideAllLists();
            this._currentSelectedButton = null;
        }
        this._setButtonStates();
    }

    _onClickMusicians(evt: any): void {
        if (this._currentSelectedButton != this.musicianBtn) {
            this._currentSelectedButton = this.musicianBtn;
            this.showMusicianList();
        } else {
            this.hideAllLists();
            this._currentSelectedButton = null;
        }
        this._setButtonStates();
    }

    _onClickExpenses(evt: any): void {
        if (this._currentSelectedButton != this.expensesBtn) {
            this._currentSelectedButton = this.expensesBtn;
            this.showExpensesList();
        } else {
            this.hideAllLists();
            this._currentSelectedButton = null;
        }
        this._setButtonStates();
    }

    _onClickFiles(evt: any): void {
        if (this._currentSelectedButton != this.filesBtn) {
            this._currentSelectedButton = this.filesBtn;
            this.showAttachmentList();
        } else {
            this.hideAllLists();
            this._currentSelectedButton = null;
        }
        this._setButtonStates();
    }

    _onClickReports(evt: any): void {
        if (this._currentSelectedButton != this.reportsBtn) {
            this._currentSelectedButton = this.reportsBtn;
            this.showReports();
        } else {
            this.hideAllLists();
            this._currentSelectedButton = null;
        }
        this._setButtonStates();
    }

    showReports(): void {
        this.hideAllLists();
        if (this._reportSelect == null) {
            var reportSelect = new ReportSelect();
            reportSelect.item = this.item;

            //domStyle.set(employmentList.domNode, "width", "95%");
            domStyle.set(reportSelect.domNode, "margin", "auto");
            //domStyle.set(employmentList.domNode, "margin-bottom", "0.75em");
            domConstruct.place(reportSelect.domNode, this.contentNode);

            reportSelect.startup();

            this._reportSelect = reportSelect;
        }

        domClass.remove(this._reportSelect.domNode, "w3-hide");
    }

    showEmploymentList(): void {
        this.hideAllLists();
        if (this._employmentList == null) {
            var employmentList = new EmploymentList();
            employmentList.item = this.item;

            //domStyle.set(employmentList.domNode, "width", "95%");
            domStyle.set(employmentList.domNode, "margin", "auto");
            //domStyle.set(employmentList.domNode, "margin-bottom", "0.75em");
            domConstruct.place(employmentList.domNode, this.contentNode);

            employmentList.startup();

            this._employmentList = employmentList;
        }

        domClass.remove(this._employmentList.domNode, "w3-hide");
    }

    hideAllLists(): void {
        if (this._employmentList != null) {
            domClass.add(this._employmentList.domNode, "w3-hide");
        }
        if (this._musicianList != null) {
            domClass.add(this._musicianList.domNode, "w3-hide");
        }
        if (this._fileList != null) {
            domClass.add(this._fileList.domNode, "w3-hide");
        }
        if (this._expensesList != null) {
            domClass.add(this._expensesList.domNode, "w3-hide");
        }

        if (this._reportSelect != null) {
            domClass.add(this._reportSelect.domNode, "w3-hide");
        }
    }

    showMusicianList(): void {
        this.hideAllLists();
        if (this._musicianList == null) {
            var musicianList = new MusicianList();
            musicianList.item = this.item;

            //domStyle.set(employmentList.domNode, "width", "95%");
            domStyle.set(musicianList.domNode, "margin", "auto");
            //domStyle.set(employmentList.domNode, "margin-bottom", "0.75em");
            domConstruct.place(musicianList.domNode, this.contentNode);

            musicianList.startup();

            this._musicianList = musicianList;
        }

        domClass.remove(this._musicianList.domNode, "w3-hide");
    }

    showExpensesList(): void {
        this.hideAllLists();
        if (this._expensesList == null) {
            var expenseList = new TravelExpenseList();
            expenseList.item = this.item;

            //domStyle.set(employmentList.domNode, "width", "95%");
            domStyle.set(expenseList.domNode, "margin", "auto");
            //domStyle.set(employmentList.domNode, "margin-bottom", "0.75em");
            domConstruct.place(expenseList.domNode, this.contentNode);

            expenseList.startup();

            this._expensesList = expenseList;
        }

        domClass.remove(this._expensesList.domNode, "w3-hide");
    }

    showAttachmentList(): void {
        this.hideAllLists();
        if (this._fileList == null) {
            var attachmentList = new AttachmentList();
            attachmentList.item = this.item;

            //domStyle.set(employmentList.domNode, "width", "95%");
            domStyle.set(attachmentList.domNode, "margin", "auto");
            //domStyle.set(employmentList.domNode, "margin-bottom", "0.75em");
            domConstruct.place(attachmentList.domNode, this.contentNode);

            attachmentList.startup();

            this._fileList = attachmentList;
        }

        domClass.remove(this._fileList.domNode, "w3-hide");
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
ActionBar.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.ActionBar';

export default mdsWidget(ActionBar);
